// RITA-1585 — Kachel „Einstellungen › Handbuch“: dasselbe Kapitelgerüst wie die Handbuch-Leiste neben dem Vertrag,
// hier für alle Handbücher (Handbuch-Auswahl über der Kapitelauswahl, Suche über alle Handbücher). Beim ersten Öffnen
// steht Kapitel 1 der Vertragserstellung, danach das zuletzt gewählte Kapitel; der Link „Ganzes Handbuch im neuen Tab
// öffnen“ bringt sein Kapitel über die Adresse mit (`?handbuch=…&kapitel=…`). Der Text kommt in einem eigenen Schritt
// (RITA-901); bis dahin steht unter der Kapitelüberschrift nichts – ohne Hinweissatz (Entscheidung Julia 31.10.2026).
// Der Seitenkopf kommt weiter über das Barrel pages/Options/components (Seitentitel-Matrix mockt genau diesen Pfad).
import React from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import EinstellungenSeitenKopf from '../../../pages/Options/components';
import HandbuchGeruest from '../../handbuch/components/HandbuchGeruest';
import useHandbuchLeiste from '../../handbuch/hooks/useHandbuchLeiste';
import { HANDBUCH_PARAMETER, KAPITEL_PARAMETER, kapitelwahlAusAdresse } from '../../handbuch/model/handbuchAdresse';
import { Kapitelwahl } from '../../handbuch/model/handbuecher';

export default function HandbuchPage() {
  const [parameter, setParameter] = useSearchParams();
  const leiste = useHandbuchLeiste('kachel', { startkapitel: kapitelwahlAusAdresse(parameter) });
  // Die Adresse folgt der Wahl (ohne Verlaufseintrag): Neuladen und Teilen zeigen das gewählte Kapitel, nicht das
  // mitgebrachte. Beim Öffnen über die Kachel bleibt die Adresse ohne Parameter.
  const waehlen = (wahl: Kapitelwahl) => {
    leiste.waehlen(wahl);
    setParameter({ [HANDBUCH_PARAMETER]: wahl.handbuchId, [KAPITEL_PARAMETER]: wahl.kapitelId }, { replace: true });
  };
  return (
    <>
      <EinstellungenSeitenKopf title="Handbuch" />
      <Box sx={{ maxWidth: 720 }}>
        <HandbuchGeruest auswahl={leiste.auswahl} onAuswahl={waehlen} alleHandbuecher ueberschrift="h2" />
      </Box>
    </>
  );
}
